var request = function request(method, route) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var url = "".concat(window.fluentFrameworkAdmin.rest.url, "/").concat(route);
  var headers = {
    'X-WP-Nonce': window.fluentFrameworkAdmin.rest.nonce
  };
  if (['PUT', 'PATCH', 'DELETE'].indexOf(method.toUpperCase()) !== -1) {
    headers['X-HTTP-Method-Override'] = method;
    method = 'POST';
  }
  return window.jQuery.ajax({
    url: url,
    type: method,
    data: data,
    headers: headers
  });
};
export default {
  get: function get(route) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return request('GET', route, data);
  },
  post: function post(route) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return request('POST', route, data);
  },
  "delete": function _delete(route) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return request('DELETE', route, data);
  },
  put: function put(route) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return request('PUT', route, data);
  },
  patch: function patch(route) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return request('PATCH', route, data);
  }
};
jQuery(document).ajaxSuccess(function (event, xhr, settings) {
  var nonce = xhr.getResponseHeader('X-WP-Nonce');
  if (nonce) {
    window.fluentFrameworkAdmin.rest.nonce = nonce;
  }
});